import { defineComponent, ref } from 'vue';
import { useMenu } from '~/composables/use-menu';
export default defineComponent({
    setup: function () {
        var _a = useMenu(), pickUpData = _a.pickUpData, inforNews = _a.inforNews;
        var timeoutId = ref(null);
        return { pickUpData: pickUpData, inforNews: inforNews, timeoutId: timeoutId };
    },
    watch: {
        pickUpData: function () {
            this.scrollToSection();
        },
        inforNews: function () {
            this.scrollToSection();
        }
    },
    methods: {
        scrollToSection: function () {
            var _this = this;
            // if (this.pickUpData.length === 0 || Object.keys(this.inforNews || {}).length === 0) {
            //   return
            // }
            if (!process.client || !window) {
                return;
            }
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            this.timeoutId = setTimeout(function () {
                var searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has('id')) {
                    var id = searchParams.get('id');
                    _this.$scrollTo("#" + id + "-section");
                }
            }, 700);
        }
    }
});
